import clsx from 'clsx';
import { COLORS } from 'styles/constants';
import type { IRatings } from './Ratings';

export interface IComment extends Pick<IRatings, 'showCommentField' | 'ratingData'> {
  commentRequired: boolean;
  comment: string;
  Rating: boolean;
  isRatingGiven: boolean;
  setComment: (value?: string) => void;
  error: boolean;
}

export const Comment = ({
  error,
  setComment,
  showCommentField,
  ratingData,
  comment,
  Rating,
  isRatingGiven,
  commentRequired,
}: IComment) => {
  if (!showCommentField) {
    return null;
  }
  return (
    <div className="pb-4 w-full">
      <label className="text-gray-500 text-sm block uppercase tracking-[2.1px] ">
        {ratingData.rating_comment_label || 'Your comment'} {commentRequired && '*'}
        <textarea
          value={comment}
          name="comment"
          disabled={!!Rating || isRatingGiven}
          onChange={(e) => {
            setComment(e.target.value);
          }}
          className={clsx(
            'border-2 block rounded-2xl mt-5 mb-2.5 py-2.5 px-5 w-full overflow-auto focus:border-gray-500',
            error ? `border-[${COLORS.error}]` : `border-[${COLORS.primary}]`,
          )}
          required={commentRequired}
        />
      </label>
      {error && (
        <p className="m-0 text-error">{ratingData.rating_comment_error || 'Required field'}</p>
      )}
    </div>
  );
};
